import { render } from "./InterfaceSelect.vue?vue&type=template&id=0baf29e0&scoped=true"
import script from "./InterfaceSelect.vue?vue&type=script&lang=js"
export * from "./InterfaceSelect.vue?vue&type=script&lang=js"

import "./InterfaceSelect.vue?vue&type=style&index=0&id=0baf29e0&scoped=true&lang=scss"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0baf29e0"]])

export default __exports__